var Interface = require('../core');
var _ = require('lodash');

Interface.type('*', {
  defaultValue: undefined,
  isOfType: function verifyTypeAnything() {
    return true;
  }
})
  .type('auto-id', {
    defaultValue: 0, // not used isOfType always succeeds
    isOfType: function verifyTypeInt() {
      return true;
    },
    convertToSync: function () {
      return _.uniqueId();
    }
  })
  .type('id', {
    defaultValue: undefined,
    convertToSource: function (source) {
      return _.isUndefined(source) ? null : source;
    },
    isOfType: function verifyIdType(val) {
      return _.isNumber(val) || _.isString(val);
    }
  })
  .type('key', Interface.type('id'));



// WEBPACK FOOTER //
// ./app/vendor/utility-js-interface/src/types/database.js